
import { useState } from 'react';
import { Signature } from '../types/signatures';

export const useSignatures = () => {
  const [signatures, setSignatures] = useState<Signature[]>([
    {
      id: '1',
      name: 'Professional',
      content: `Best regards,
John Doe
Senior Recruiter
Recruitment Agency
john.doe@agency.com
(555) 123-4567`
    },
    {
      id: '2',
      name: 'Casual',
      content: `Thanks,
John`
    },
    {
      id: '3',
      name: 'Detailed',
      content: `Best regards,

John Doe
Senior Recruiter
Recruitment Agency
📧 john.doe@agency.com
📱 (555) 123-4567
🌐 www.recruitmentagency.com

Follow us on LinkedIn: linkedin.com/company/recruitment-agency`
    }
  ]);

  const addSignature = (name: string, content: string) => {
    const newSignature: Signature = {
      id: Date.now().toString(),
      name,
      content
    };
    setSignatures(prev => [...prev, newSignature]);
  };

  const updateSignature = (id: string, name: string, content: string) => {
    setSignatures(prev => 
      prev.map(sig => 
        sig.id === id 
          ? { ...sig, name, content }
          : sig
      )
    );
  };

  const removeSignature = (id: string) => {
    setSignatures(prev => prev.filter(sig => sig.id !== id));
  };

  return { 
    signatures, 
    addSignature, 
    updateSignature, 
    removeSignature 
  };
};
